import React from 'react';

// @ts-ignore
import Icon from 'assets/images/traps/STM.svg';

interface IconProps {
  height?: number;
  width?: number;
}

const SnapTrapMouseIcon: React.FC<IconProps> = ({ height = 30, width = 30 }) => {
  return <img src={Icon} height={height} width={width} alt="Mouse Icon" />;
};

export default SnapTrapMouseIcon;
